'use client'
import React from "react";
import {Link} from 'react-router-dom';
function NotificationItem({
  icon,
  main,
  time,
  isUnread,
}) {
  return (
    <li className={`d-flex align-items-center ${isUnread ? "unread" : ""}`}>
      <img src={icon} alt="icon" className="lazy-img icon" />
      <div className="flex-fill ps-2">
        <h6>You have {main} new mails</h6>
        <span className="time">{time} hours ago</span>
      </div>
    </li>
  );
}

type IProps = {
  setIsOpenSidebar?: React.Dispatch<React.SetStateAction<boolean>>
}
const DashboardHeader = ({setIsOpenSidebar}:IProps) => {
  const handleOpen = () => {
    if(setIsOpenSidebar){
      setIsOpenSidebar(true)
    }
  }
  return (
    <header className="dashboard-header">
      <div className="d-flex align-items-center justify-content-end">
        <button onClick={handleOpen} className="dash-mobile-nav-toggler d-block d-md-none me-auto">
          <span></span>
        </button>
        {/* <form action="#" className="search-form">
          <input type="text" placeholder="Search here.." />
          <button>
            <img src="/assets/dashboard/images/icon/icon_10.svg" alt="search" className="lazy-img m-auto" />
          </button>
        </form>
        <div className="profile-notification ms-2 ms-md-5 me-4">
          <button
            className="noti-btn dropdown-toggle"
            type="button"
            id="notification-dropdown"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false"
          >
            <img src="/assets/dashboard/images/icon/icon_11.svg" alt="Notification" className="lazy-img" />
            <div className="badge-pill"></div>
          </button>
          <ul className="dropdown-menu" aria-labelledby="notification-dropdown">
            <li>
              <h4>Notification</h4>
              <ul className="style-none notify-list">
                <NotificationItem
                  icon="/assets/dashboard/images/icon/icon_36.svg"
                  main="3"
                  time="3"
                  isUnread={true}
                />
                <NotificationItem
                  icon="/assets/dashboard/images/icon/icon_37.svg"
                  main="5"
                  time="6"
                  isUnread={false}
                />
                <NotificationItem
                  icon="/assets/dashboard/images/icon/icon_38.svg"
                  main="7"
                  time="9"
                  isUnread={true}
                />
              </ul>
            </li>
          </ul>
        </div> */}
        <div>
          <Link
            to="/profile"
            className="job-post-btn tran3s"
          >
            Profil
          </Link>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
